'use strict';

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');

/**
 * All parameters in `pattern` will be replaced with values from `q`.
 * E.g. `/:locales/search/:type` becomes `/en-GB/search/last-searches`
 *
 * @param {String} routePattern - Pattern of route with variables e.g. '/:locale/search/:type'
 * @param {Object} q - query params
 * @param {Object} search - search/get parameters that will be added to the URL
 *
 * @returns {Object}
 */
function routeToLink(routePattern) {
  var q = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var search = arguments.length > 2 ? arguments[2] : undefined;
  var REGEX_OPTIONAL_PARAMS = /\/:[^/]+\?/gi;

  var query = _rollupPluginBabelHelpers.objectSpread2({}, q);

  Object.keys(query).forEach(function (key) {
    return query[key] === undefined || query[key] === null ? delete query[key] : {};
  });
  var link = routePattern;
  Object.keys(query).forEach(function (key) {
    var regex = new RegExp(":".concat(key, "((\\/|$)|(\\?))"), 'gi');
    link = link.replace(regex, "".concat(query[key], "$2"));
  });
  link = link.replace(REGEX_OPTIONAL_PARAMS, '');

  if (search) {
    var arr = [];
    Object.keys(search).forEach(function (key) {
      arr.push("".concat(key, "=").concat(search[key]));
    });

    if (arr.length) {
      link = "".concat(link, "/?").concat(arr.join('&'));
    }
  }

  return link;
}

module.exports = routeToLink;
